import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import AppLayout from "../../lib/components/Layout/app-layout";
import Header from "../../lib/components/Header";
import marketplaceService from "../../service/marketplaceService";
import organizationservice from "../../service/organizationservice";
import pathnames from "../../constants/pathnames";
import { normalizePlans } from "./utils";
import ItemForm from "./components/ItemForm";
import "./marketplace.scss";

/**
 * B2 — Create a new marketplace catalogue item.
 */
const CreateMarketplaceItem = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const metaQuery = useQuery({
    retry: false,
    queryKey: ["marketplace-meta"],
    queryFn: () => marketplaceService.getMeta(),
  });

  const plansQuery = useQuery({
    retry: false,
    queryKey: ["subscription-plans"],
    queryFn: () => organizationservice.getSubscriptionPlans(),
  });

  const plans = useMemo(() => normalizePlans(plansQuery.data), [plansQuery.data]);

  return (
    <AppLayout>
      <Header
        title="New marketplace item"
        description="Publish a capacity pack or module for customers to buy"
      />
      <div className="p-3 bg-light marketplace-page" style={{ minHeight: "100%" }}>
        <div className="mp-detail-toolbar">
          <Button
            startIcon={<ArrowBack />}
            color="inherit"
            onClick={() => navigate(pathnames.MARKETPLACE_ADDONS)}
          >
            Back to catalogue
          </Button>
        </div>

        <div className="mp-item-shell mp-item-card">
          <h1>New marketplace item</h1>
          <p className="sub">
            Select a capability, set customer-facing name and price, then publish or save
            as hidden.
          </p>
          <ItemForm
            mode="create"
            plans={plans}
            meta={metaQuery.data}
            onCancel={() => navigate(pathnames.MARKETPLACE_ADDONS)}
            onSuccess={() => {
              queryClient.invalidateQueries({ queryKey: ["marketplace-items"] });
              queryClient.invalidateQueries({ queryKey: ["marketplace-items-stats"] });
              queryClient.invalidateQueries({ queryKey: ["marketplace-meta"] });
            }}
          />
        </div>
      </div>
    </AppLayout>
  );
};

export default CreateMarketplaceItem;
